/**
 * animations.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import {
  animate,
  AnimationEntryMetadata,
  AnimationMetadata,
  AnimationStateMetadata,
  state,
  style,
  transition,
  trigger
} from "@angular/core";

const SLOW_REMOVAL_DEF : AnimationStateMetadata[] = [
  transition("keep => remove", [
    style({opacity: 1, height: "*", overflow: "hidden"}),
    animate("1s 0.3s ease-out", style({opacity: 0, height: 0}))
  ]),
  state("remove", style({opacity: 0, height: 0, display: "none"}))
];

const SLOW_DETACH_DEF : AnimationStateMetadata[] = [
  transition("* => void", [
    style({opacity: 1, height: "*", overflow: "hidden"}),
    animate("0.7s 0.3s ease-out", style({opacity: 0, height: 0}))
  ]),
  state("void", style({opacity: 0, height: 0, display: "none"}))
];

const SLOW_ATTACH_DEF : AnimationStateMetadata[] = [
  state("void", style({opacity: 0, height: 0, display: "none"})),
  transition("void => *", [
    style({opacity: 0, height: 0, overflow: "hidden"}),
    animate("0.3s 0.7s", style({opacity: 1, height: "*", display: "*"}))
  ])
];

export const SLOW_REMOVAL : AnimationEntryMetadata =
  trigger("slowRemoval", SLOW_REMOVAL_DEF);

export const SLOW_DETACH : AnimationEntryMetadata =
  trigger("slowDetach", SLOW_DETACH_DEF);

export const SLOW_ATTACH : AnimationEntryMetadata =
  trigger("slowAttach", SLOW_ATTACH_DEF);



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/support/utilities/animations.ts